import { EthAddr } from '@shared/SchemaTypes'
import { PoolDynamicOverviewCTO, PoolFlexOverviewCTO, PoolOverviewCTO } from '@shared/sharedTypes'
import { useErc20Balance } from './useErc20Balance'

interface UsePoolLiquidityBalanceOptions {
  poolAddr: EthAddr
  poolOverview?: PoolOverviewCTO | PoolFlexOverviewCTO | PoolDynamicOverviewCTO
  enabled?: boolean
  refetchInterval?: number
}

interface UsePoolLiquidityBalanceReturn {
  poolBalance: bigint
  isLoading: boolean
  error: Error | null
  refetch: () => Promise<void>
  liquidityAssetAddr: EthAddr | null
}

/**
 * Hook to fetch and subscribe to pool liquidity asset balance updates
 * This integrates with your existing pool infrastructure
 */
export const usePoolLiquidityBalance = ({
  poolAddr,
  poolOverview,
  enabled = true,
  refetchInterval,
}: UsePoolLiquidityBalanceOptions): UsePoolLiquidityBalanceReturn => {
  const liquidityAssetAddr = poolOverview?.liquidityAssetAddr || null

  const {
    balance: poolBalance,
    isLoading,
    error,
    refetch,
  } = useErc20Balance({
    tokenAddress: liquidityAssetAddr as EthAddr,
    accountAddress: poolAddr,
    enabled: enabled && !!liquidityAssetAddr && !!poolAddr,
    refetchInterval,
  })

  return {
    poolBalance,
    isLoading,
    error,
    refetch,
    liquidityAssetAddr,
  }
}
